import { c as _c } from "react/compiler-runtime";
import { anyspendService } from "../../../anyspend/services/anyspend.js";
import { useB3Config } from "../../../global-account/react/index.js";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
export function useAnyspendQuote(req) {
  const $ = _c(17);
  const {
    partnerId
  } = useB3Config();
  let t0;
  if ($[0] !== req) {
    t0 = JSON.stringify(req);
    $[0] = req;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== partnerId || $[3] !== t0) {
    t1 = ["useAnyspendQuote", t0, partnerId];
    $[2] = partnerId;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== partnerId || $[6] !== req) {
    t2 = () => anyspendService.getQuote(req, partnerId);
    $[5] = partnerId;
    $[6] = req;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const t3 = Boolean(req.srcChain && req.dstChain && req.srcTokenAddress && req.dstTokenAddress && BigInt(req.type === "swap" || req.type === "hype_duel" || req.type === "x402_swap" || req.type === "custom_exact_in" ? req.amount : req.type === "mint_nft" ? req.price : req.type === "join_tournament" ? req.price : req.type === "fund_tournament" ? req.fundAmount : req.payload.amount) !== BigInt(0));
  let t4;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = {
      queryKey: t1,
      queryFn: t2,
      enabled: t3,
      refetchInterval: 10000,
      retry: false
    };
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const {
    data,
    isLoading,
    refetch,
    error
  } = useQuery(t4);
  let t5;
  let t6;
  if ($[12] !== data || $[13] !== error || $[14] !== isLoading || $[15] !== refetch) {
    t6 = {
      anyspendQuote: data,
      isLoadingAnyspendQuote: isLoading,
      getAnyspendQuoteError: error,
      refetchAnyspendQuote: refetch
    };
    $[12] = data;
    $[13] = error;
    $[14] = isLoading;
    $[15] = refetch;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  t5 = t6;
  return t5;
}